import { authFetch } from '@addictivegroup/addictive-auth'

/**
 * The permission library asks Core for pages and held permissions. Offline those calls fail;
 * the last answer is kept per person so the panel shows the same screens and buttons it did
 * online (the server still decides every write when it arrives).
 */
function cached(key, url) {
  return async () => {
    const storageKey = `addcrm:perm:${key}`
    try {
      const response = await authFetch(url)
      if (!response.ok) throw new Error(`HTTP ${response.status}`)
      const data = await response.json()
      try {
        localStorage.setItem(storageKey, JSON.stringify(data))
      } catch {
        // cache is best-effort
      }
      return data
    } catch (error) {
      const raw = localStorage.getItem(storageKey)
      if (raw) return JSON.parse(raw)
      throw error
    }
  }
}

export const pagesFetcher = cached('pages', '/api/permissions/panel-app/my-pages')
export const permissionsFetcher = cached('permissions', '/api/permissions/panel-app/my-permissions')

export function forgetPermissionCache() {
  try {
    localStorage.removeItem('addcrm:perm:pages')
    localStorage.removeItem('addcrm:perm:permissions')
  } catch {
    // nothing to forget
  }
}
